// src/axiosConfig.js
import axios from 'axios';

// تنظیم axios interceptor برای اضافه کردن token به تمام درخواست‌ها
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios;